/**
 * Cocinaeasylunch Archetype
 * 
 * @author Daniel Lepe
 * Agregada la función quicktableFilters y archetypeCocinaeasylunchCFG, útiles para filtar en quicktable y 
 * agregar dependencias de configuración Cocinaeasylunch => Cocinaeasylunch_hijo respectivamente.
 * 
 * @date 6 de Agosto, 2024
 * @version 1.1
 * 
 * @author Daniel Lepe
 * @date 6 de Agosto, 2024
 * @version 1.0
 */
import _ from 'lodash'

const baseController = 'Cocinaeasylunch'

const baseIndex = baseController + '/index'

const archetype = () => {
    return [
        { key: 'id', type: 'hidden' },
        { key: 'plan_id', type: 'select', label: 'Menú/Plan' },
        null,
        [
            { key: 'cede_tipo', type: 'select', label: 'Tipo de sede', options: cedeTipoFilter.options, default: cedeTipoFilter.options[0] },
            { key: 'menu_clase', type: 'text', label: 'Clase del menú' },
        ],
        null,
        [
            {
                key: 'fecha_inicio',
                type: 'date',
                label: 'Fecha de inicio',
            },
            {
                key: 'mes',
                type: 'select',
                label: 'Mes',
                options: mesesOptions,
                readonly: true,
            },
        ],
        null,
        // { key: 'estatus', type: 'select', label: 'Estatus', options: ['1', '0'] },
        [
            preciotipo,
            { key: 'posicion', type: 'select', label: 'Posición', options: Array.from({ length: 25 }, (_, i) => i + 1), default: 1 },
        ],
    ];
};
const mesesOptions = [
    { value: 'enero', text: 'Enero' },
    { value: 'febrero', text: 'Febrero' },
    { value: 'marzo', text: 'Marzo' },
    { value: 'abril', text: 'Abril' },
    { value: 'mayo', text: 'Mayo' },
    { value: 'junio', text: 'Junio' },
    { value: 'julio', text: 'Julio' },
    { value: 'agosto', text: 'Agosto' },
    { value: 'septiembre', text: 'Septiembre' },
    { value: 'octubre', text: 'Octubre' },
    { value: 'noviembre', text: 'Noviembre' },
    { value: 'diciembre', text: 'Diciembre' },
]
const captions = [
    { key: 'plan', label: 'Menú' },
    { key: 'cede_tipo', label: 'Tipo' },
    { key: 'menu_clase', label: 'Clase del menú' },
    { key: 'mes', label: 'Mes' },
    { key: 'fecha_inicio', label: 'Fecha de inicio' },
    // { key: 'estatus', label: 'Estatus' },
    // { key: 'tipo', label: 'Tipo' },
    { key: 'certificacion_estatus' },
    { key: 'certificacion_responsable' },
    { key: '_', label: '' }
];

const cedeTipoFilter = {
    key: 'tipo',
    type: 'select',
    required: true,
    options: ['Escuela', 'Empresa'],
    default: 'Escuela'
},
    preciotipo = { key: 'tipo', type: 'select', label: 'Precio', options: ['Base', 'Premium'], default: 'Base' };

// const estatusFilterSample = {
//     key: 'estatus',
//     required: false,
//     options: ['1', '0'],
//     default: null,
// };

const quicktableFilters = () => {
    return [
        // estatusFilterSample,
        cedeTipoFilter
    ]
}

const archetypeCocinaeasylunchCFG = () => {
    return [
        // { key: 'id', type: 'hidden' },
        // { key: 'Cocinaeasylunch_id', type: 'hidden', },
        // { key: 'descriptor', label: 'Description', readonly: true },
    ]
};

let automodalHandler = (conceptId) => {
    let str = baseController + '/' + 'define' + ((_.isNil(conceptId)) ? '' : ('/' + conceptId));
    // console.log("isNil", _.isNil(conceptId))
    return str;
}


export {
    captions,
    baseIndex,
    cedeTipoFilter,
    archetype,
    archetypeCocinaeasylunchCFG,
    quicktableFilters,
    automodalHandler
}